<template>
     <div class="site-view">
        
        <Header :title="Title"/>
        <section class="page-section darken">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div class="text-wrap">
                            <div class="mb4">
                                <a name="route-options-section"></a>
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Route Options</b></p>
                                <h1>Route Options</h1>
                            </div>
                        </div>
                        <VerticalTab  :data="veticalTabData" :colorStyle="colorCode"/>
                         <!-- <VerticalTab  :data="veticalTabDataRight" :colorStyle="colorCode"/> -->
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-6">
                        <div  class="align-col-center">
                         <img src="@/assets/images/Belfast/Phase2option/RouteOption.png">
                        </div>
                        <div  class="align-col-center">
                          <img src="@/assets/images/Belfast/Phase2option/imageroute1.png">
                        </div>
                            
                    </div>
                    
                </div>
                <!-- <div class="row">
                    
                   
                    <div class="col m12 l6"> 
                        <div class="text-wrap">
                            <div class="mb4">
                                <p class="hr-title mb4">&nbsp;</p>
                               
                            </div>
                        </div>                       
                         <VerticalTab  :data="veticalTabDataRight" :colorStyle="colorCode"/>
                    </div>
                     <div class="col m12 l6">
                        <div  class="align-col-center">
                            <img src="@/assets/images/Belfast/Phase2option/imageroute1.png">
                        </div>
                    </div>
                </div> -->
            </div>
        </section>
        <Options/>
        <TwoColumnFooter/>
        <Footer />
    </div>
</template>

<script>
import TwoColumnFooter from "@/components/belfast/TwoColumnFooter";
import VerticalTab from "@/components/belfast/VerticalTab";
import Options from "@/components/belfast/Options";
import Footer from "@/components/belfast/Footer";
import Header from "@/components/belfast/HeroHeaderOtherPages";
export default {
  name: "page-options",
   components: {
    Header,
    Footer,
    TwoColumnFooter,
    Options,
    VerticalTab
  },
  mounted(){
    if(this.$route.params.jumpTo){
        location.hash = "#" + this.$route.params.jumpTo;
    }
  },
  data() {
    return {
       Title:"Route Options",
       colorCode:'dark',
        // veticalTabDataRight: [
        //     {
        //         title:"Initial assessment",
        //         text: "<p>The initial stage of the Route Options Assessment was to undertake a high-level assessment of a long list of route options. Unpromising/unsuitable options were discarded based on the following:</p><ul><li>how the route could contribute to meeting the project objectives and wider Government policies and strategies; and</li><li>the key viability and acceptability criteria of each route, including how the route could accommodate the necessary BRT infrastructure.</li></ul>"
        //     },
        //     {
        //         title:"Detailed assessment",
        //         text: "<p>A detailed assessment was then undertaken for the most promising route options. The key issues that were assessed in order to refine the viable route options were as follows:</p><ul><li>the suitability of the route to provide priority lanes for the BRT2 service;</li><li> the potential positive impact of the route on public transport journey times and reliability;</li><li> the accessibility of the route to key locations of employment, healthcare, leisure, commerce and regeneration;</li><li> whether or not the route would provide value for money;</li><li> the practical feasibility of implementing the route;</li><li> whether the project would be within available funding if the route is selected;</li><li> the commercial viability of the route;</li><li> the potential of the route to encourage more people to transfer from private car to public transport.</li></ul> "
        //     },
        //     {
        //         title:"Route Options Studies",
        //         text: "<p>It is essential that the BRT2 routes are able to physically accommodate the priority bus lanes which will enable the BRT2 system to operate reliably. Detailed investigations have been carried out on a number of route options for BRT2 in order to identify the most suitable routes to be taken forward for further investigation and detailed design. For each potential route we have investigated:</p><ul><li>Road geometry and layouts</li><li>Traffic ﬂows</li><li>Parking</li><li>Adjacent land use</li></ul><p>These elements have been assessed as part of a detailed Route Audit Report.</p>" 
        //     },
        //     {
        //         title:"Route Options Assessment",
        //         text: "<p>Assessments were carried out to identify the route options, that is, the routes that are deemed to be capable of delivering a scheme which fulfils the following objectives of BRT2:</p><ul><li>Provide a safe, efficient and high quality public transport service;</li><li>Support sustainable economic growth and regeneration;</li><li> Provide equality through enhanced accessibility; and </li><li> Support social inclusion and the integration of communities</li></ul>" 
        //     }
        // ],
        veticalTabData: [
            {
                title:"Route Options Assessment",
                text: "<p>Assessments were carried out to identify the route options, that is, the routes that are deemed to be capable of delivering a scheme which fulfils the following objectives of BRT2:</p> <ul><li>Provide a safe, efficient and high-quality public transport service; </li><li>Support sustainable economic growth and regeneration; </li><li>Provide equality through enhanced accessibility; and </li><li>Support social inclusion and the integration of communities.</li></ul><p>It is also essential that the BRT2 routes are able to physically accommodate the priority bus lanes which will enable the BRT2 system to operate reliably. Detailed investigations have been carried out on a number of route options for BRT2 in order to identify the most suitable routes to be taken forward for further investigation.</p><p>For each potential route we have investigated:</p> <ul><li>Road geometry and layouts </li><li>Traffic flows </li><li>Parking </li><li>Adjacent land use</li></ul>" 
            },
            {
                title:"Initial assessment",
                text: "<p>The initial stage of the Route Options Assessment was to undertake a high-level assessment of a long list of route options. This allowed unpromising options to be discarded at an early stage. The assessment included a review of: </p> <ul><li>how the route could contribute to meeting the project objectives and wider Government policies and strategies; and </li><li> the key viability and acceptability criteria of each route, including how the route could accommodate the necessary BRT infrastructure.</li></ul>"
            },
            {
                title:"Detailed assessment",
                text: "<p>A detailed assessment was then undertaken for the most promising route options. The key issues that were assessed in order to refine the viable route options were as follows:</p><ul><li> the suitability of the route to provide priority lanes for the BRT2 service; </li><li>the potential positive impact of the route on public transport journey times and reliability; </li><li>the accessibility of the route to key locations of employment, healthcare, leisure, commerce and regeneration; </li><li> whether or not the route would provide value for money; </li><li>the practical feasibility of implementing the route; </li><li> whether the project would be within available funding if the route is selected; </li><li> the commercial viability of the route; and </li><li> the potential of the route to encourage more people to transfer from private car to public transport.</li></ul> "
            }
            
        ],
    
    }
  }
};
</script>
